<template>
  <button
    class="mr-1 flex h-6 w-6 cursor-pointer items-center justify-center rounded border-0 text-xs"
    :class="{
      'bg-black bg-opacity-15': isActive,
      'hover:bg-black hover:bg-opacity-10': !isActive,
    }"
    @click.stop="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'TipTapToggleButton',

  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],
}
</script>
